import { post } from '../../../../../api/baseUrl';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getAllActions } from '../../../../../store/ai2';
import type { RootState, AppDispatch } from '../../../../../store';
import axios from 'axios';

export const useDeleteAction = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  const postDeleteAction = async (actionId: number) => {
    setIsLoading(true);
    const searchParams = new URLSearchParams(location.search);
    const access_token = searchParams.get('access_token');
    try {
      const payload = {
        actionId,
        tenancyId: selectedTenancy?.tenancy_id,
        access_token,
      };
      const result = await post(`deleteAction`, payload);

      dispatch(getAllActions(access_token, selectedTenancy));
      return result;
    } catch (error: unknown) {
      console.error('An error occurred during delete action', error);
      let message = 'Unknown error in delete action';
      if (axios.isAxiosError(error) && error.response?.data?.message) {
        message = error.response.data.message;
      }
      setErrorMessage(message);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postDeleteAction,
    errorMessage,
    isLoading,
  };
};
